import React from 'react';
import PropTypes from 'prop-types';
import classes from './styles.module.scss';

const Info = ({
  className, title, children, patientWarning, physicianWarning,
}) => {
  const infoWrapperCls = [classes.wrapper, className];

  if (patientWarning) infoWrapperCls.push(classes.patientWarning);

  if (physicianWarning) infoWrapperCls.push(classes.physicianWarning);

  return (
    <div className={infoWrapperCls.join(' ')}>
      <div className={classes.title}>{title}</div>

      <div className={classes.content}>
        {children}
      </div>
    </div>
  );
};

Info.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.any,
  patientWarning: PropTypes.bool,
  physicianWarning: PropTypes.bool,
};

Info.defaultProps = {
  className: '',
  children: null,
  patientWarning: false,
  physicianWarning: false,
};
export default Info;
